// Enhanced validation result interface
export interface ValidationResult {
  isValid: boolean;
  errors: string[];
  warnings?: string[];
}

// Prime validation functions
export function validatePrimeAmount(amount: number, fieldName: string = 'montant', max?: number): ValidationResult {
  const errors: string[] = [];
  
  if (isNaN(amount) || !isFinite(amount)) {
    errors.push(`Le ${fieldName} doit être un nombre valide`);
  } else if (amount < 0) {
    errors.push(`Le ${fieldName} ne peut pas être négatif`);
  } else if (max && amount > max) {
    errors.push(`Le ${fieldName} ne peut pas dépasser ${max.toFixed(2)}€`);
  } else if (!max && amount > 10000) {
    errors.push(`Le ${fieldName} ne peut pas dépasser 10 000€`);
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}

export function validateReimbursementRate(rate: number): ValidationResult {
  const errors: string[] = [];
  
  if (isNaN(rate) || !isFinite(rate)) {
    errors.push('Le taux de remboursement doit être un nombre valide');
  } else if (rate < 0) {
    errors.push('Le taux de remboursement ne peut pas être négatif');
  } else if (rate > 100) {
    errors.push('Le taux de remboursement ne peut pas dépasser 100%');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}

export function validateWorkTimePercentage(percentage: number): ValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];
  
  if (isNaN(percentage) || !isFinite(percentage)) {
    errors.push('Le temps de travail doit être un nombre valide');
  } else if (percentage < 0) {
    errors.push('Le temps de travail ne peut pas être négatif');
  } else if (percentage > 100) {
    errors.push('Le temps de travail ne peut pas dépasser 100%');
  } else if (percentage < 25) {
    warnings.push('Un temps de travail inférieur à 25% est inhabituel');
  }
  
  return {
    isValid: errors.length === 0,
    errors,
    warnings
  };
}

export function validateGradeEchelon(grade: number | null, echelon: number, validEchelons: number[] = []): ValidationResult {
  const errors: string[] = [];
  
  if (!grade) {
    errors.push('Veuillez sélectionner un grade');
  } else if (validEchelons.length > 0 && !validEchelons.includes(echelon)) {
    errors.push('Veuillez sélectionner un échelon valide');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}

